
const SET_ADMIN_TYPE = 'setadmintype';
const SET_CARDSPERMISSIONS_CONFIG = "setcardspermissionsconfig"
const SET_HIGHLIGHTEDMENUITEM = "highlightMenuitem"
const SET_MENU_LOADER = 'setmainmenuloader';
const setadmintype = (payload) => {
    return {
        type: SET_ADMIN_TYPE,
        payload,
    };
};
const setcardspermissionsconfig = (payload) => {
    return {
        type: SET_CARDSPERMISSIONS_CONFIG,
        payload,
    };
}
const setmainmenuloader = (payload) => {
    return {
        type: SET_MENU_LOADER,
        payload,
    };
}
const highlightMenuitem = (payload) => {
    return {
        type: SET_HIGHLIGHTEDMENUITEM,
        payload,
    };
}
let initialState = {
    AdminType: '', cardspermissionsconfig: [], highlightedmenuItem: '', mainmenuloader: true
};
const commonReducer = (state, action) => {
    if (!state) {
        state = {
            ...initialState,
            ...state
        }
    }
    switch (action.type) {
        case SET_ADMIN_TYPE:
            state = { ...state, AdminType: action.payload };
            return state;
        case SET_CARDSPERMISSIONS_CONFIG:
            state = { ...state, cardspermissionsconfig: action.payload };
            return state;
        case SET_HIGHLIGHTEDMENUITEM:
            state = { ...state, highlightedmenuItem: action.payload };
            return state;
        case SET_MENU_LOADER:
            state = { ...state, mainmenuloader: action.payload };
            return state;
        default:
            return state;
    }
}

export default commonReducer;
export { setadmintype, setcardspermissionsconfig, highlightMenuitem, setmainmenuloader };

